<template>
  <div class="backdrop">
    <div ref="modal" class="container">
      <div class="content">
        <div v-if="title !== '' || subTitle !== ''" class="title-content">
          <h2 v-if="title">{{ title }}</h2>
          <span v-if="subTitle">{{ subTitle }}</span>
        </div>
        <font-awesome-icon :icon="['fas', 'times']" class="close-icon" @click="closeModal" />
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Ref, ref } from 'vue';
import { useStore } from 'vuex';
import { onClickOutside } from '@vueuse/core';

export default {
  name: 'Modal',
  props: {
    title: String,
    subTitle: String,
  },
  setup(): {
    closeModal: () => void;
    modal: Ref<HTMLDivElement | null>;
  } {
    const store = useStore();
    const closeModal = (): void => {
      store.dispatch('ui/toggleModalStatus');
    };

    const modal: Ref<HTMLDivElement | null> = ref(null);
    onClickOutside(modal, () => closeModal());

    return {
      closeModal,
      modal,
    };
  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 3;

  .container {
    display: flex;
    flex-direction: column;
    background-color: $light-grey;
    justify-content: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-box-shadow: 0 3px 7px rgb(0 0 0 / 20%);
    -moz-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.2);
    box-shadow: 0 3px 7px rgb(0 0 0 / 20%);
    height: 100%;
    width: 100%;
    z-index: 2;
    overflow-y: initial;

    @media (min-width: $mobile) {
      border-radius: 0.5rem;
      height: auto;
      max-height: 90%;
      width: 80%;
    }

    @media (min-width: $tablet) {
      width: auto;
    }

    .content {
      overflow-y: auto;
      padding: 2rem;

      .title-content {
        margin: 1rem 0 1.5rem;
        max-width: 25rem;

        h2 {
          margin: 0;
          @media (min-width: $tablet) {
            max-width: 30rem;
          }
        }

        span {
          display: block;
          margin-top: 0.5rem;
        }
      }

      .close-icon {
        height: 1rem;
        width: 1rem;
        border-radius: 50%;
        position: absolute;
        top: 0.75rem;
        right: 0.75rem;
        padding: 1rem;
        cursor: pointer;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
          box-shadow 0.15s ease-in-out;

        &:hover {
          background-color: rgba(0, 0, 0, 0.075);
        }
      }
    }
  }
}
</style>
